module.exports = __webpack_public_path__ + "img/service-dashuju1.5a9bfb84.svg";